<script>
import axios from "axios";

import {
  authMethods,
  authFackMethods,
  notificationMethods,
} from "@/state/helpers";
import { mapState } from "vuex";

import appConfig from "@/app.config";
import { required, email } from "vuelidate/lib/validators";

/**
 * Login component
 */
export default {
  page: {
    title: "Login",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      email: "",
      password: "",
      submitted: false,
      authError: null,
      tryingToLogIn: false,
      isAuthError: false,
    };
  },
  validations: {
    email: {
      required,
      email,
    },
    password: {
      required,
    },
  },
  computed: {
    ...mapState("authfack", ["status"]),
    notification() {
      return this.$store ? this.$store.state.notification : null;
    },
  },
  methods: {
    ...authMethods,
    ...authFackMethods,
    ...notificationMethods,
    // Try to log the user in with the username
    // and password they provided.
    tryToLogIn() {
      this.submitted = true;
      // stop here if form is invalid
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      } else {
        axios
          .post("/login", {
            email: this.email,
            password: this.password,
          })
          .then((res) => {
            const { response = "", details = "" } = res.data;
            if (response === false) {
              this.tryingToLogIn = false;
              this.authError = details;
              this.isAuthError = true;
            } else {
              // console.log(email, password);
              this.email = res.data.user.email;
              this.password = res.data.user.password;
              this.tryingToLogIn = false;
              this.isAuthError = false;
              const user = `
                {"email":"${res.data.user.email}",
                "username": "${res.data.user.nombre}",
                "id_usuario": "${res.data.user.id_usuario}",
                "token": "${res.data.token}",
                "id_negocio": "${res.data.user.id_negocio}",
                "id_empresa": "${res.data.user.id_empresa}",
                "id_user_municipio": "${res.data.user.id_municipio}"
                }`;
              localStorage.setItem("user", user);
              localStorage.setItem("token", res.data.token);
              localStorage.setItem(
                "permits",
                JSON.stringify(res.data.user.permits)
              );
              this.$router.push("/");
              return user;
            }
          })
          .catch((error) => {
            console.log(error);
            this.tryingToLogIn = false;
            this.authError = "Hubo un error";
            this.isAuthError = true;
          });
      }
    },
  },
  mounted() {},
};
</script>

<template>
  <div class="login-view" style="height: 100vh; width: 100%">
    <div class="container-fluid" style="height: 100%">
      <div class="row" style="height: 100%">
        <!-- <div class="col col-md-6 login-col-left d-none d-md-block">
          <div class="bg-filter-content d-flex align-items-end">
            <h1 style="color: white; font-size: 4rem;">Bienvenido!</h1>
          </div>
        </div> -->
        <div class="col col-12">
          <div class="d-flex justify-content-center align-items-center h-100">
            <div class="card shadow-lg overflow-hidden" style="width: 100%; max-width: 480px;">
              <div class="card-body pt-10">
                <b-alert
                  v-model="isAuthError"
                  variant="danger"
                  class="mt-3"
                  dismissible
                  >{{ authError }}</b-alert
                >
                <div
                  v-if="notification.message"
                  :class="'alert ' + notification.type"
                >
                  {{ notification.message }}
                </div>

                <b-form class="p-2" @submit.prevent="tryToLogIn">
                  <div class="d-flex justify-content-center mb-8">
                    <b-img :src="require('@/assets/images/logo-purple.png')" width="168" alt="Juntas Podemos Ahorrar"></b-img>
                  </div>
                  <b-form-group
                    class="mb-3"
                    id="input-group-1"
                    label="Email"
                    label-for="input-1"
                  >
                    <b-form-input
                      id="input-1"
                      v-model="email"
                      type="text"
                      placeholder="Ingresa tu correo electrónico"
                      :class="{ 'is-invalid': submitted && $v.email.$error }"
                    ></b-form-input>
                    <div
                      v-if="submitted && $v.email.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.email.required">Email is required.</span>
                      <span v-if="!$v.email.email"
                        >Please enter valid email.</span
                      >
                    </div>
                  </b-form-group>

                  <b-form-group
                    class="mb-6"
                    id="input-group-2"
                    label="Contraseña"
                    label-for="input-2"
                  >
                    <b-form-input
                      id="input-2"
                      v-model="password"
                      type="password"
                      placeholder="Ingresa tu contraseña"
                      :class="{
                        'is-invalid': submitted && $v.password.$error,
                      }"
                    ></b-form-input>
                    <div
                      v-if="submitted && !$v.password.required"
                      class="invalid-feedback"
                    >
                      Password is required.
                    </div>
                  </b-form-group>
                  <div class="mt-3 d-grid">
                    <b-button type="submit" variant="primary" class="btn-block fw-bold" style="color: white; background-color: var(--bs-purple);">
                      Iniciar sesion
                    </b-button>
                  </div>
                </b-form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
